<div class="page-content overflow-x-hidden">
  <section class="hero--bg hero" id="hero" style="margin-bottom: -5rem">
    <header id="header" class="container">
      <lib-ikp-header-logo />
    </header>
    @if (isLoaded) {
      <header class="hero-header container pb-8">
        <div class="row">
          <div class="col-lg-7 align-self-center">
            @if (showAuthServerAlert) {
              <mwe-alert
                [type]="authServerAlertData.type"
                [titleKey]="authServerAlertData.title"
                [messageKey]="authServerAlertData.message"
                [class.two-active-alerts]="showTemporaryAlert() && showAuthServerAlert"
              />
            }
            <h1 class="mb-5 mb-lg-6">
              <div class="h6 mb-3 text-white">
                <span>{{ 'frontpage.titleSmall' | translate }}</span>
              </div>
              <div class="h1 mb-0 text-white">
                <span>{{ 'frontpage.titleBig' | translate }}</span>
              </div>
            </h1>
            @if (currentToast()) {
              <div class="mb-2">
                <mwe-inline-notification [type]="currentToast().type" [titleKey]="currentToast().title" />
              </div>
            }
            @if (queryParamEmail()) {
              <div class="mb-5 mb-lg-6 email-hint">
                <mwe-infobox type="info" titleKey="frontpage.emailHint.title" [messageKey]="this.textWithEmail()">
                  <mwe-button-link
                    btnId="copy-email"
                    label="frontpage.emailHint.buttonLabel"
                    prependIconClass="fas fa-copy"
                    size="md"
                    color="blue"
                    customCss="justify-content-start align-items-start mt-2"
                    (clicked)="copyEmailToClipboard()"
                  />
                </mwe-infobox>
              </div>
            }
            @if (showTemporaryAlert() && !this.showAuthServerAlert) {
              <div class="mb-5 mb-lg-6">
                <mwe-alert
                  [type]="temporaryAlert().type"
                  [titleKey]="temporaryAlert().title"
                  [messageKey]="temporaryAlert().message"
                  [iconClassOverwrite]="temporaryAlert().icon"
                />
              </div>
            }
            <div class="mb-5 mb-lg-6">
              <mwe-button
                [showHoverEffect]="true"
                (clicked)="login()"
                class="d-block mb-3"
                buttonId="mwe-home-login"
                color="white"
                labelKey="frontpage.login"
              />
              <mwe-button
                (clicked)="register()"
                buttonId="mwe-home-register"
                color="white"
                category="secondary"
                labelKey="frontpage.register"
                class="d-block mb-3"
              />
            </div>
          </div>
          <div class="col-lg-5 position-relative d-lg-block d-none" aria-hidden="true">
            <div class="mx-auto ratio ratio-smartphone" style="max-width: 236px; filter: drop-shadow(0 22px 45px rgba(0, 0, 0, 0.33))">
              <div class="smartphone-display">
                <img
                  class="img-fluid w-100 rounded"
                  ngSrc="assets/img/ikp-frontpage-smartphone-bg.png"
                  alt=""
                  width="210"
                  height="335"
                  priority
                />
              </div>
            </div>
          </div>
        </div>
      </header>
    }
  </section>
</div>
<ikp-footer />
